"use strict";

import { fixIosSvgFilters } from "@/utils/svgUtils";

export function Fighter(svgText) {
  [this.svg, this.elements] = parseSvg(svgText);

  function parseSvg(text) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, "image/svg+xml");

    const svg = doc.getElementsByTagName("svg")[0];

    // Global iOS Fix for SVG Filters
    fixIosSvgFilters(svg);

    const elements = findElements(svg);

    return [svg, elements];
  }

  function findElements(e) {
    let idCounter = 0;
    const getIdCounter = () => ++idCounter;

    function _recursive(e, elements) {
      if (e == null) return;

      // if (e.tagName.toLowerCase() === "symbol") return;

      const colors = extractColors(e);
      if (colors != null) {
        if (!e.id) {
          let prefix = e.tagName;
          if (e.parentNode && e.parentNode.id) {
            prefix = `${e.parentNode.id}_${e.tagName}`;
          }
          // Use a random suffix to ensure uniqueness within the file context simple enough
          // or use a closure counter if we had one. Using random for simplicity in this scope
          // or we can add a counter to the parseSvg scope. 
          // Let's rely on a counter passed to recursive or just outer scope variable.
          // Since we can't easily change signature of recursive without changing all calls, 
          // assuming we define counter in parseSvg.
          e.id = `${prefix}_${getIdCounter()}`;
        }
        elements[e.id] = colors;
      }

      for (const child of e.children) {
        _recursive(child, elements);
      }
    }

    function extractColors(e) {
      const fill = extractFill(e);
      const stroke = extractStroke(e);
      const [roundel, w, h] = extractRoundel(e);
      const qr = extractQrCode(e);
      const digit = extractDigit(e);
      const number = extractNumber(e);
      const stopColor = extractStopColor(e);

      let result = null;
      if (fill != null) {
        result = {
          el: e,
          fill,
        };
      } else if (stroke != null) {
        result = {
          el: e,
          stroke,
        };
      } else if (stopColor != null) {
        result = {
          el: e,
          stopColor,
        };
      } else if (roundel != null) {
        result = {
          el: e,
          roundel,
          width: w,
          height: h,
        };
      } else if (qr != null) {
        result = {
          el: e,
          qr,
        };
      } else if (digit != null) {
        result = {
          el: e,
          digit,
        };
      } else if (number != null) {
        result = {
          el: e,
          number,
        };
      }

      return result;
    }

    function extractFill(e) {
      const fill = e.getAttribute("fill");
      if (typeof fill == "string" && fill != "none" && fill.startsWith("#")) {
        return fill;
      }

      return null;
    }

    function extractStroke(e) {
      const stroke = e.getAttribute("stroke");
      if (typeof stroke == "string" && stroke != "none") {
        return stroke;
      }

      return null;
    }

    function extractRoundel(e) {
      const m = e.id.match(/(roundel_\w+)$/);
      if (m == null) return [null, null, null];
      else {
        const path = e.getAttribute("xlink:href");
        const r = path.match(/.*\/(.+)[.]svg$/);

        const w = e.getAttribute("width");
        const h = e.getAttribute("height");

        if (r == null) return [null, w, h];
        else return [r[1], w, h];
      }
    }

    function extractQrCode(e) {
      if (e.id != "qr") {
        return null;
      } else {
        const path = e.getAttribute("xlink:href");
        const r = path.match(/.*\/(.+)[.]svg$/);
        if (r == null) return null;
        else return r[1];
      }
    }

    function extractDigit(e) {
      const m = e.id.match(/(digit_\w+)$/);
      if (m == null) return null;
      else {
        const path = e.getAttribute("xlink:href");
        const r = path.match(/#n(\d)/);
        if (r == null) return null;
        else return r[1];
      }
    }

    function extractNumber(e) {
      const m = e.id.match(/(number_\w+)$/);
      if (m == null) return null;
      else {
        const number = e.textContent;
        return number;
      }
    }

    function extractStopColor(e) {
      if (e.tagName !== "stop") return null;
      const stopColor = e.getAttribute("stop-color");
      if (typeof stopColor == "string" && stopColor != "none") {
        return stopColor;
      }

      return null;
    }

    const elements = {};
    _recursive(e, elements);
    return elements;
  }
}
